export const hasAccess = (allowedRoles: string[], userRole: string): boolean => {
    return allowedRoles.includes(userRole);
  };
  